export function noop(..._args: any[]): void {}
